/**
 * Фильтрация записей реестра по виду (kind_slug) и тексту
 */

export const filterEntries = (entries, filterKind, query) => {
  let result = entries;

  if (filterKind && filterKind !== 'all') {
    result = result.filter(e => e.kind_slug === filterKind);
  }

  if (query && query.trim()) {
    const q = query.toLowerCase();
    result = result.filter(e =>
      e.name.toLowerCase().includes(q) ||
      e.code.toLowerCase().includes(q) ||
      (e.description || '').toLowerCase().includes(q) ||
      (e.tags || []).some(t => (t.name || t).toLowerCase().includes(q)) ||
      String(e.attributes?.owner || '').toLowerCase().includes(q) ||
      String(e.attributes?.domain || '').toLowerCase().includes(q)
    );
  }

  return result;
};
